import { Injectable } from '@angular/core';
@Injectable()
export class NavigationService {
    backParameters:any;

    constructor() { 
    }
    
    public setBackParameters(backParameters:any){
        this.backParameters = backParameters;
    }
    
    public getBackParameters(){
        let parameters = this.backParameters;
        this.backParameters = null;
        return parameters;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/navigation.service.ts
 **/